import { call, put, take } from 'redux-saga/effects';
import ERRORS from 'constants/errors';
import { createLogger } from 'helpers/logger';
import { setError, startLoading, stopLoading, actionFirebaseLoginSuccess } from 'reduxConfig/auth.creators';
import { initFirebaseMfa } from './firebaseMfa';
import { initFirebaseNativeMfa } from './firebaseNativeMfa';
import authTypes from 'reduxConfig/auth.types';

const log = createLogger('[auth-saga] authLogin:');

export function* authLogin({ email, password, isNewUser }) {
  yield put(startLoading());
  try {
    const userCredential = yield call(window.FIREBASE.login, email, password);
    yield put(actionFirebaseLoginSuccess({ password, userCredential, isNewUser }));
  } catch (loginError) {
    if (loginError.code === 'auth/multi-factor-auth-required') {
      const resolver = yield call(window.FIREBASE.getMultiFactorResolver, loginError);
      const { credential } = loginError;
      !credential && log.warn('signup credential are empty');
      yield call(initFirebaseMfa, { credential, resolver, recaptchaContainerId: 'recaptcha-verifier' });
      const firebaseMfaSuccess = yield take(authTypes.FIREBASE_MFA_SUCCESS);
      yield put(
        actionFirebaseLoginSuccess({ password, userCredential: firebaseMfaSuccess.userCredential, isNewUser })
      );
    } else if (loginError.code === 'auth-nbx/multi-factor-auth-required') {
      yield call(initFirebaseNativeMfa);
      const firebaseMfaSuccess = yield take(authTypes.FIREBASE_MFA_SUCCESS);
      yield put(
        actionFirebaseLoginSuccess({ password, userCredential: firebaseMfaSuccess.userCredential, isNewUser })
      );
    } else if (loginError.code === 'auth/too-many-requests') {
      yield put(setError(ERRORS.tooManyRequests));
    } else if (loginError.code === 'auth/user-not-found' || loginError.code === 'auth/wrong-password') {
      yield put(setError(ERRORS.credentials));
    } else {
      yield put(setError(ERRORS.login));
    }
  } finally {
    yield put(stopLoading());
  }
}
